// extracted by mini-css-extract-plugin
export default {"DictionaryContainer":"VideosPage_DictionaryContainer__uBiZA","DictionaryMainContainer":"VideosPage_DictionaryMainContainer__x2Ubj"};